export default __webpack_public_path__ + "static/media/PreviewOverlayFrench.3c5e4b59.png";